import React, { useState } from 'react';
import './WebViewWarningModal.css';
import { getBrowserOpenInstructions, copyCurrentURLToClipboard } from '../utils/browserDetection';

const WebViewWarningModal = ({ browserName, onClose }) => {
  const [copied, setCopied] = useState(false);
  
  const instructions = getBrowserOpenInstructions(browserName);
  
  const handleCopyURL = async () => {
    const success = await copyCurrentURLToClipboard();
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };
  
  return (
    <div className="webview-modal-overlay" onClick={onClose}>
      <div className="webview-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="webview-modal-header">
          <div className="webview-warning-icon">⚠️</div>
          <h2>Open in Browser Required</h2>
        </div>
        
        <div className="webview-modal-body">
          <p className="webview-main-message">
            You're currently viewing this page in {browserName}. 
            Google Sign-In doesn't work in in-app browsers for security reasons.
          </p>
          
          <div className="webview-instructions-box">
            <h3>How to continue:</h3>
            <p className="webview-instructions">{instructions}</p>
          </div>
          
          <div className="webview-alternative">
            <p><strong>Alternative:</strong> You can also use email sign-in, which works in any browser.</p>
          </div>
          
          <button 
            className="webview-copy-button"
            onClick={handleCopyURL}
          >
            {copied ? '✓ URL Copied!' : '📋 Copy Page URL'}
          </button>
        </div>
        
        <div className="webview-modal-footer">
          <button className="webview-close-button" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebViewWarningModal;
